export default "__VITE_ASSET__DIZ439l8__"